// hooks/useFetchProfile.js
import { useEffect, useState } from "react";
import { getMyProfileDetails } from "api/authService";
import { useAuth } from "context/UserContext";
export const useFetchProfile = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const {setUpdateUser}=useAuth()

  const fetchProfile = async () => {
    try {
      const res = await getMyProfileDetails();
      if (res.success) {
        setProfile(res.body);
        setUpdateUser(res.body)
      }
    } catch (err) {
      console.error("Failed to fetch profile:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if(!profile){
      fetchProfile();
    }
  }, [profile]);
  return { profile, loading, refetchProfile: fetchProfile };
};
